<ng-container>
  <div class="blog-comments contaner-fluid">
    <div class="row">
      <ng-container *ngIf="contentlet$ | async as comment">
        <ng-container *ngIf="getAuthorContentByIdentifier$(comment.commentAuthor?.identifier) | async as commentAuthor">
          <div class="col-md-2">
            <div class="comment-author-image">
              <custom-dot-cms-blog-author
                [identifier]="commentAuthor.identifier"
                isBlog="blogAuthor"
                isCommentAuthor="commentAuthor"
              ></custom-dot-cms-blog-author>
            </div>
          </div>
          <div class="col-md-10">
            <div class="row">
              <div class="col-md-12">
                <div class="author-details">
                  <span>{{ commentAuthor?.firstName }}</span>
                  <span class="comment-date"
                    ><i *ngIf="comment?.postDate" class="icon-clock"></i>
                    {{ comment?.postDate | date : 'medium' }}
                  </span>
                </div>
                <div class="blog-comments">
                  <div class="comments">
                    <p [ishServerHtml]="comment?.body"></p>
                  </div>
                </div>
                <!--TODO reply comment-->
                <!-- <ng-container *ngFor="let reply of comment?.reply">
              <div class="reply-comments">
                <div class="reply">
                  <custom-dot-cms-blog-comments [identifier]="reply?.identifier"></custom-dot-cms-blog-comments>
                </div>
              </div>
            </ng-container> -->
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</ng-container>
